export default {
  title: 'Inserisci importo rimborso',
  description: 'Disponibile per rimborso: {{amount}}',
  form: {
    amount: {
      label: 'Rimborso',
    },
    reason: {
      label: 'Motivo',
      options: {
        requested_by_customer: 'richiesto dal cliente',
        reclamation: 'reclamo',
        communication_error: 'errore di comunicazione',
        other: 'altro',
      },
    },
    manual_reason: {
      label: 'Inserisci motivo rimborso',
    },
  },
  feedback: {
    amount_too_small: 'Importo rimborso minimo {{amount}}',
    amount_too_big: 'Importo rimborso massimo {{amount}}',
    payment_frozen:
      'Rimborso già richiesto dal cliente. {{provider}} è in contatto con il cliente riguardo al rimborso',
  },
  buttons: {
    refund: 'Rimborso',
    cancel: 'Annulla',
  },
  toasts: {
    refund_successful: 'Rimborso di {{amount}} avviato con successo!',
  },
};
